module.exports = __webpack_public_path__ + "img/exclamation-diamond.b53e07f6.svg";